// Branded type aliases for bus events.
// In P1 these are plain string aliases; in P2 they will become true branded types
// (e.g. `string & { __brand: 'ObjectId' }`) without requiring changes to consumers
// that route through the `objectId(s)` helper.

// TODO P2: migrate to branded type
export type ObjectId = string;

// Constructs an ObjectId from a raw string. Identity in P1; will perform the
// brand cast in P2.
export function objectId(s: string): ObjectId {
    return s;
}
